import React from 'react';
import { PropTypes } from 'prop-types';
import get from 'lodash/get';
import Skeleton from 'Common/Components/Skeleton';
import Text from './styled';

const PasswordCell = ({ rowInfo, showSkeleton, field, hidePass }) => {
  const label = get(rowInfo, `original.value.${field}`, '');

  if (showSkeleton) return <Skeleton />;
  return (
    <Text>
      { hidePass ? '**********' : label }
    </Text>
  );
};

PasswordCell.propTypes = {
  rowInfo: PropTypes.object.isRequired,
  field: PropTypes.string.isRequired,
  showSkeleton: PropTypes.bool,
  hidePass: PropTypes.bool
};

PasswordCell.defaultProps = {
  field: '',
  showSkeleton: false,
  hidePass: true
};

export default PasswordCell;
